import React from 'react';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Clock, CheckCircle2, LogOut, UserCog } from 'lucide-react';

const KitchenHeader = ({
  user,
  selectedDate,
  onDateChange,
  onSwitchDashboard,
  timeLogStatus,
  timerSubmitting,
  onStartTimer,
  onStopTimer,
  onLogout,
}) => {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm mb-6 -mx-6 -mt-6">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Left: Logo + Title */}
        <div className="flex items-center gap-3">
          <div className="bg-orange-500 p-2 rounded-lg">
            <span className="text-xl font-bold text-white">JP</span>
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900 tracking-tight leading-none">Kitchen Dashboard</h1>
            <Badge variant="outline" className="mt-1 bg-orange-50 text-orange-700 border-orange-200 font-medium py-0 h-5 text-[10px]">
              Operational View
            </Badge>
          </div>
        </div>

        {/* Right: Date picker + controls */}
        <div className="flex items-center gap-3">
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
            className="h-9 px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
          />

          <div className="text-right mr-2 hidden sm:block">
            <p className="text-sm font-bold text-gray-900">{user?.name || user?.full_name}</p>
            <p className="text-[10px] text-gray-500 uppercase tracking-widest leading-tight">{user?.role} Staff</p>
          </div>

          {onSwitchDashboard && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => onSwitchDashboard('selector')}
              className="flex items-center gap-2 font-bold shadow-sm h-9 border-orange-500 text-orange-600 hover:bg-orange-50"
            >
              <UserCog size={16} />
              <span className="hidden sm:inline">Switch</span>
            </Button>
          )}

          {timeLogStatus === 'none' && (
            <Button
              variant="default"
              size="sm"
              disabled={timerSubmitting}
              onClick={onStartTimer}
              className="flex items-center gap-2 font-bold shadow-sm h-9 bg-orange-500 hover:bg-orange-600 text-white"
            >
              <Clock size={16} />
              <span className="hidden sm:inline">Start Timer</span>
            </Button>
          )}

          {timeLogStatus === 'active' && (
            <Button
              variant="default"
              size="sm"
              disabled={timerSubmitting}
              onClick={onStopTimer}
              className="flex items-center gap-2 font-bold shadow-sm h-9 bg-red-600 hover:bg-red-700 text-white"
            >
              <Clock size={16} />
              <span className="hidden sm:inline">Stop Timer</span>
            </Button>
          )}

          {timeLogStatus === 'completed' && (
            <Badge variant="outline" className="h-9 flex items-center gap-2 bg-green-50 text-green-700 border-green-200">
              <CheckCircle2 size={16} />
              <span className="hidden sm:inline">Done</span>
            </Badge>
          )}

          <Button
            variant="destructive"
            size="sm"
            onClick={onLogout}
            className="flex items-center gap-2 font-bold shadow-sm h-9"
          >
            <LogOut size={16} />
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default KitchenHeader;
